import { render } from "./PartyRefObjCom.vue?vue&type=template&id=59baf21f"
import script from "./PartyRefObjCom.vue?vue&type=script&lang=js"
export * from "./PartyRefObjCom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__